import { render, staticRenderFns } from "./VehicleManagement.vue?vue&type=template&id=8689fffe"
import script from "./VehicleManagement.vue?vue&type=script&lang=js"
export * from "./VehicleManagement.vue?vue&type=script&lang=js"
import style0 from "./VehicleManagement.vue?vue&type=style&index=0&id=8689fffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports